import { Descriptions, Tooltip } from "antd";
import React, { useCallback, useMemo, useState } from "react";
import { planUtils, styleGenerators } from "../utils/calendarUtils";

const PlanDot = React.memo(
  ({
    plan,
    planIndex,
    dateObj,
    line,
    onDoubleClick,
    dragProps,
    isDropping,
  }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = useCallback(() => {
      if (!isDropping) setIsHovered(true);
    }, [isDropping]);

    const handleMouseLeave = useCallback(() => {
      if (!isDropping) setIsHovered(false);
    }, [isDropping]);

    const tooltipContent = useMemo(
      () => (
        <div style={{ maxWidth: "300px" }}>
          <div
            style={{
              fontWeight: "bold",
              marginBottom: "8px",
              color: "#1890ff",
              borderBottom: "1px solid #d9d9d9",
              paddingBottom: "4px",
            }}
          >
            Plan Details
          </div>
          <Descriptions size="small" column={1} colon={false}>
            {/* <Descriptions.Item label="Plan ID">
              <span style={{ fontWeight: "bold" }}>
                {plan.plan_id || plan.id || "N/A"}
              </span>
            </Descriptions.Item> */}
            <Descriptions.Item label="Style: ">
              <span style={{ color: "#262626" }}>{plan.title || "N/A"}</span>
            </Descriptions.Item>
            <Descriptions.Item label="Sub Style No.: ">
              <span style={{ color: "#262626", wordBreak: "break-word" }}>
                {plan.sub_style || plan.sub_style_no || "N/A"}
              </span>
            </Descriptions.Item>
            <Descriptions.Item label="PO: ">
              <span style={{ color: "#262626", wordBreak: "break-word" }}>
                {plan.po_no || plan.po || "N/A"}
              </span>
            </Descriptions.Item>
            {plan.plan_curve_mh && (
              <Descriptions.Item label="Man Hours: ">
                <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                  {plan.plan_curve_mh} hrs
                </span>
              </Descriptions.Item>
            )}
            {plan.plan_curve_efficiency && (
              <Descriptions.Item label="Efficiency: ">
                <span style={{ color: "#52c41a", fontWeight: "bold" }}>
                  {plan.plan_curve_efficiency}
                </span>
              </Descriptions.Item>
            )}
            {plan.plan_curve_qty && (
              <Descriptions.Item label="Quantity: ">
                <span style={{ color: "#722ed1", fontWeight: "bold" }}>
                  {Number(plan.plan_curve_qty).toLocaleString()} pcs
                </span>
              </Descriptions.Item>
            )}
            {"is_editable" in plan && (
              <Descriptions.Item label="Status">
                <span
                  style={{
                    color: plan.is_editable ? "#52c41a" : "#f5222d",
                    fontWeight: "bold",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    backgroundColor: plan.is_editable ? "#f6ffed" : "#fff2f0",
                    border: `1px solid ${plan.is_editable ? "#52c41a" : "#f5222d"
                      }`,
                  }}
                >
                  {plan.is_editable ? "✓ Editable" : "✗ Read Only"}
                </span>
              </Descriptions.Item>
            )}
          </Descriptions>
        </div>
      ),
      [plan],
    );

    if (!plan.is_start) return null;

    return (
      <Tooltip
        title={tooltipContent}
        placement="bottomLeft"
        trigger="click"
        overlayStyle={{ maxWidth: "320px" }}
        color="#fff"
        overlayInnerStyle={{
          color: "#000",
          backgroundColor: "#fff",
          border: "1px solid #d9d9d9",
          borderRadius: "6px",
          boxShadow: "0 6px 16px 0 rgba(0, 0, 0, 0.08)",
        }}
      >
        <div
          onDoubleClick={() => onDoubleClick(plan, dateObj, line)}
          draggable={planUtils.isDraggable(dateObj) && !isDropping}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={styleGenerators.getPlanDotStyle(
            planIndex,
            isDropping,
            isHovered,
          )}
          title={`Plan ${plan.id || planIndex + 1}${plan.title ? ` - ${plan.title}` : ""
            }${plan.sub_style || plan.sub_style_no ? ` - ${plan.sub_style || plan.sub_style_no}` : ""}${plan.po_no || plan.po ? ` - ${plan.po_no || plan.po}` : ""
            }${isDropping ? " - Updating..." : ""}`}
          {...dragProps}
        />
      </Tooltip>
    );
  },
);

PlanDot.displayName = "PlanDot";

export default PlanDot;
